import { render, staticRenderFns } from "./ordered.vue?vue&type=template&id=08bc007f&scoped=true"
import script from "./ordered.vue?vue&type=script&lang=js"
export * from "./ordered.vue?vue&type=script&lang=js"
import style0 from "./ordered.vue?vue&type=style&index=0&id=08bc007f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc007f",
  null
  
)

export default component.exports